import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEffect, useState } from 'react';
import { BaseSubmissionInformation } from './base-submission-information.component';
import { styleVariables, TextAreaBox } from '@lib/common';
import { Button, Skeleton, Space, Tooltip } from 'antd';
import styled from 'styled-components';
import { SubmissionScore } from '@module/assignment';
import { UnixTimestamp } from '@module/form';
import { CommentBox } from '../comment/comment-box.component';
import { EditOutlined } from '@ant-design/icons';
import { CommentPreview } from '../comment/comment-preview.component';
import { InfoCircleFilled } from '@ant-design/icons';
import { SubmissionResultStatusType } from '@module/assignment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SubmissionResultCard = styled.div.withConfig({
  displayName: "homework-submission-informationcomponent__SubmissionResultCard",
  componentId: "sc-xrgqai-0"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;padding:16px;border-radius:8px;gap:6px;background-color:", ";height:100%;"], styleVariables.colors.blue1);
var GrayText = styled.label.withConfig({
  displayName: "homework-submission-informationcomponent__GrayText",
  componentId: "sc-xrgqai-1"
})(["font-weight:400;font-size:14px;line-height:24px;color:", ";", " text-align:center;width:100%;"], styleVariables.colors.gray11, function (props) {
  return props.theme.media.desktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: 16px;\n  "])));
});
var HeadingText = styled(GrayText).withConfig({
  displayName: "homework-submission-informationcomponent__HeadingText",
  componentId: "sc-xrgqai-2"
})(["font-weight:700;"]);
var SubmissionScoreText = styled.label.withConfig({
  displayName: "homework-submission-informationcomponent__SubmissionScoreText",
  componentId: "sc-xrgqai-3"
})(["font-weight:600;font-size:24px;line-height:28px;color:", ";", ""], styleVariables.colors.blue2, function (props) {
  return props.theme.media.desktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 28px;\n  "])));
});
var SubmissionScoreSmall = styled.span.withConfig({
  displayName: "homework-submission-informationcomponent__SubmissionScoreSmall",
  componentId: "sc-xrgqai-4"
})(["color:", ";font-weight:600;font-size:16px;margin-left:6px;"], styleVariables.colors.gray11);
var StyledTitle = styled.label.withConfig({
  displayName: "homework-submission-informationcomponent__StyledTitle",
  componentId: "sc-xrgqai-5"
})(["font-size:", ";font-weight:", ";"], styleVariables.font.fontSizeOriginal, styleVariables.font.fontWeightStrong);
var SectionRow = styled.div.withConfig({
  displayName: "homework-submission-informationcomponent__SectionRow",
  componentId: "sc-xrgqai-6"
})(["display:flex;gap:12px;flex-wrap:wrap;width:100%;"]);
var SectionCard = styled.div.withConfig({
  displayName: "homework-submission-informationcomponent__SectionCard",
  componentId: "sc-xrgqai-7"
})(["flex:1;min-width:120px;padding:10px 14px;border-radius:8px;border:1px solid ", ";background:", ";display:flex;flex-direction:column;gap:4px;"], styleVariables.colors.gray3, styleVariables.colors.gray1);
var SectionLabel = styled.span.withConfig({
  displayName: "homework-submission-informationcomponent__SectionLabel",
  componentId: "sc-xrgqai-8"
})(["font-size:11px;font-weight:600;letter-spacing:0.8px;text-transform:uppercase;color:", ";"], styleVariables.colors.gray11);
var SectionCorrectText = styled.span.withConfig({
  displayName: "homework-submission-informationcomponent__SectionCorrectText",
  componentId: "sc-xrgqai-9"
})(["font-size:13px;font-weight:600;color:", ";"], styleVariables.colors.gray13);
var SectionProgressBar = styled.div.withConfig({
  displayName: "homework-submission-informationcomponent__SectionProgressBar",
  componentId: "sc-xrgqai-10"
})(["width:100%;height:5px;border-radius:999px;background:", ";position:relative;overflow:hidden;margin-top:4px;&::after{content:'';position:absolute;left:0;top:0;height:100%;width:", "%;background:", ";}"], styleVariables.colors.gray3, function (p) {
  return Math.min(100, Math.max(0, p.$percent));
}, styleVariables.colors.green1);
var LegendGroup = styled.div.withConfig({
  displayName: "homework-submission-informationcomponent__LegendGroup",
  componentId: "sc-xrgqai-11"
})(["display:flex;flex-wrap:wrap;gap:16px;"]);
var LegendItem = styled.div.withConfig({
  displayName: "homework-submission-informationcomponent__LegendItem",
  componentId: "sc-xrgqai-12"
})(["display:flex;align-items:center;gap:6px;font-size:13px;color:", ";"], styleVariables.colors.gray11);
var LegendDot = styled.span.withConfig({
  displayName: "homework-submission-informationcomponent__LegendDot",
  componentId: "sc-xrgqai-13"
})(["width:12px;height:12px;border-radius:50%;background:", ";flex-shrink:0;"], function (p) {
  return p.$color;
});
var StyledSpaceContainer = styled(Space).withConfig({
  displayName: "homework-submission-informationcomponent__StyledSpaceContainer",
  componentId: "sc-xrgqai-14"
})(["width:100%;"]);
var StyledTooltip = styled(Tooltip).withConfig({
  displayName: "homework-submission-informationcomponent__StyledTooltip",
  componentId: "sc-xrgqai-15"
})([""]);
var ProgressBar = styled.div.withConfig({
  displayName: "homework-submission-informationcomponent__ProgressBar",
  componentId: "sc-xrgqai-16"
})(["width:100%;height:10px;border-radius:999px;background:", ";position:relative;overflow:hidden;margin-top:4px;margin-bottom:2px;&::after{content:'';position:absolute;left:0;top:0;height:100%;width:", "%;background:", ";}"], styleVariables.colors.gray3, function (p) {
  return Math.min(100, Math.max(0, p.$percent));
}, function (p) {
  return p.$isFail ? styleVariables.colors.red3 : styleVariables.colors.green1;
});
var StatusText = styled.div.withConfig({
  displayName: "homework-submission-informationcomponent__StatusText",
  componentId: "sc-xrgqai-17"
})(["width:100%;text-align:center;margin-top:6px;font-weight:600;color:", ";"], function (p) {
  return p.$isFail ? styleVariables.colors.red3 : styleVariables.colors.green1;
});
var FeedbackCard = styled.div.withConfig({
  displayName: "homework-submission-informationcomponent__FeedbackCard",
  componentId: "sc-xrgqai-18"
})(["display:flex;flex-direction:column;gap:6px;padding:10px 12px;border-radius:8px;background:", ";border-left:4px solid ", ";"], styleVariables.colors.gray2, styleVariables.colors.blue2);
var FeedbackHeader = styled.div.withConfig({
  displayName: "homework-submission-informationcomponent__FeedbackHeader",
  componentId: "sc-xrgqai-19"
})(["display:flex;align-items:center;gap:8px;font-weight:600;color:", ";"], styleVariables.colors.gray13);
var Quoted = styled.div.withConfig({
  displayName: "homework-submission-informationcomponent__Quoted",
  componentId: "sc-xrgqai-20"
})(["position:relative;padding-left:0;&:before{content:'\"'; color: ", "; margin-right: 2px; } &:after { content: '\"';color:", ";margin-left:2px;}"], styleVariables.colors.gray11, styleVariables.colors.gray11);
var ScrollArea = styled.div.withConfig({
  displayName: "homework-submission-informationcomponent__ScrollArea",
  componentId: "sc-xrgqai-21"
})(["max-height:140px;overflow-y:auto;padding-right:4px;"]);
var SubmittedTag = styled.span.withConfig({
  displayName: "homework-submission-informationcomponent__SubmittedTag",
  componentId: "sc-xrgqai-22"
})(["display:inline-flex;align-items:center;gap:6px;padding:6px 10px;border-radius:999px;background:", ";color:", ";font-weight:600;font-size:12px;"], styleVariables.colors.blue1, styleVariables.colors.blue2);
export var HomeworkSubmissionInformation = function HomeworkSubmissionInformation(props) {
  var isLoadingGetFormReleaseById = props.isLoadingGetFormReleaseById,
      isLoadingGetSubmissionById = props.isLoadingGetSubmissionById,
      formRelease = props.formRelease,
      assignment = props.assignment,
      isLoadingGetAssignmentById = props.isLoadingGetAssignmentById,
      submission = props.submission,
      label = props.label,
      _props$isShowingTotal = props.isShowingTotalScore,
      isShowingTotalScore = _props$isShowingTotal === void 0 ? false : _props$isShowingTotal,
      isUpdating = props.isUpdating,
      onComment = props.onComment,
      isPreviewMode = props.isPreviewMode,
      isLoadingGetAttendeeById = props.isLoadingGetAttendeeById,
      correctQuestionsPerSection = props.correctQuestionsPerSection;

  var _useState = useState(false),
      isCommentEditing = _useState[0],
      setIsCommentEditing = _useState[1];

  var renderSubmissionResultInformation = function renderSubmissionResultInformation() {
    var _submission$result, _submission$result$st, _submission$result2, _submission$result2$s;

    var isLoadingResources = isLoadingGetSubmissionById || isLoadingGetAssignmentById || isLoadingGetFormReleaseById;

    if (isLoadingResources) {
      return /*#__PURE__*/_jsx(Skeleton, {
        active: true
      });
    }

    var totalScore = formRelease.sections.reduce(function (sum, currentSection) {
      return sum + currentSection.totalScore;
    }, 0);
    var numericScore = submission.result.score === SubmissionScore["default"].value ? 0 : submission.result.score;
    var percent = totalScore > 0 ? Math.round(numericScore / totalScore * 100) : 0;
    var statusId = submission === null || submission === void 0 ? void 0 : (_submission$result = submission.result) === null || _submission$result === void 0 ? void 0 : (_submission$result$st = _submission$result.status) === null || _submission$result$st === void 0 ? void 0 : _submission$result$st.id;
    var isFail = statusId !== undefined ? statusId !== SubmissionResultStatusType.Passed : false;
    return /*#__PURE__*/_jsxs(SubmissionResultCard, {
      children: [/*#__PURE__*/_jsx(HeadingText, {
        children: label.totalScore
      }), /*#__PURE__*/_jsxs(SubmissionScoreText, {
        children: [numericScore, /*#__PURE__*/_jsxs(SubmissionScoreSmall, {
          children: ["/", totalScore, " ", label.score]
        })]
      }), /*#__PURE__*/_jsx(ProgressBar, {
        $percent: percent,
        $isFail: isFail
      }), /*#__PURE__*/_jsx(StatusText, {
        $isFail: isFail,
        children: submission === null || submission === void 0 ? void 0 : (_submission$result2 = submission.result) === null || _submission$result2 === void 0 ? void 0 : (_submission$result2$s = _submission$result2.status) === null || _submission$result2$s === void 0 ? void 0 : _submission$result2$s.name
      })]
    });
  };

  useEffect(function () {
    if (!isUpdating) {
      setIsCommentEditing(false);
    }
  }, [isUpdating]);

  var renderSectionSummaries = function renderSectionSummaries() {
    if (isLoadingGetFormReleaseById) {
      return /*#__PURE__*/_jsx(Skeleton, {
        active: true
      });
    }

    return /*#__PURE__*/_jsx(SectionRow, {
      children: formRelease.sections.map(function (section, index) {
        var _correctQuestionsPerS, _section$totalQuestio;

        var correct = (_correctQuestionsPerS = correctQuestionsPerSection === null || correctQuestionsPerSection === void 0 ? void 0 : correctQuestionsPerSection[index]) !== null && _correctQuestionsPerS !== void 0 ? _correctQuestionsPerS : 0;
        var total = (_section$totalQuestio = section.totalQuestion) !== null && _section$totalQuestio !== void 0 ? _section$totalQuestio : 0;
        var percent = total > 0 ? Math.round(correct / total * 100) : 0;
        return /*#__PURE__*/_jsxs(SectionCard, {
          children: [/*#__PURE__*/_jsxs(SectionLabel, {
            children: [label.section, " ", index + 1]
          }), /*#__PURE__*/_jsxs(SectionCorrectText, {
            children: [correct, "/", total, " ", label.numberOfCorrectAnswer]
          }), /*#__PURE__*/_jsx(SectionProgressBar, {
            $percent: percent
          })]
        }, index);
      })
    });
  };

  var renderComment = function renderComment() {
    var commentPreviewLabel = {
      noContent: label.noComment,
      seeMore: label.seeMore,
      seeLess: label.seeLess
    };

    if (isPreviewMode) {
      return /*#__PURE__*/_jsx(CommentPreview, {
        value: submission !== null && submission !== void 0 && submission.isEmptyComment() ? '' : submission === null || submission === void 0 ? void 0 : submission.comment,
        label: commentPreviewLabel
      });
    }

    if (isCommentEditing) {
      return /*#__PURE__*/_jsx(CommentBox, {
        label: _objectSpread(_objectSpread({}, label), {}, {
          placeholder: label.enterComment
        }),
        onSave: onComment,
        value: submission === null || submission === void 0 ? void 0 : submission.comment,
        onCancel: function onCancel() {
          return setIsCommentEditing(false);
        },
        loading: isUpdating
      });
    }

    if (submission !== null && submission !== void 0 && submission.isEmptyComment()) {
      if (assignment.isEnded()) {
        return /*#__PURE__*/_jsx(TextAreaBox, {
          placeholder: label.enterComment,
          onClick: function onClick() {
            return setIsCommentEditing(true);
          }
        });
      }

      return /*#__PURE__*/_jsx(StyledTooltip, {
        title: label.disabledText,
        children: /*#__PURE__*/_jsx(TextAreaBox, {
          placeholder: label.enterComment,
          disabled: true
        })
      });
    }

    return /*#__PURE__*/_jsx(CommentPreview, {
      value: submission === null || submission === void 0 ? void 0 : submission.comment,
      label: commentPreviewLabel
    });
  };

  return /*#__PURE__*/_jsx(BaseSubmissionInformation, _objectSpread(_objectSpread({}, props), {}, {
    userExtra: submission !== null && submission !== void 0 && submission.submitTime ? /*#__PURE__*/_jsxs(SubmittedTag, {
      children: [label.submittedOn, ": ", UnixTimestamp.convertToDate(submission.submitTime)]
    }) : undefined,
    resultColumn: renderSubmissionResultInformation(),
    children: !isLoadingGetAttendeeById && /*#__PURE__*/_jsxs(StyledSpaceContainer, {
      direction: "vertical",
      size: 'small',
      children: [renderSectionSummaries(), /*#__PURE__*/_jsxs(FeedbackCard, {
        children: [/*#__PURE__*/_jsxs(FeedbackHeader, {
          children: [/*#__PURE__*/_jsx(InfoCircleFilled, {
            style: {
              color: styleVariables.colors.blue2
            }
          }), /*#__PURE__*/_jsx(StyledTitle, {
            children: label.teacherComment
          }), !isCommentEditing && !(submission !== null && submission !== void 0 && submission.isEmptyComment()) && !isPreviewMode && /*#__PURE__*/_jsx(Button, {
            icon: /*#__PURE__*/_jsx(EditOutlined, {}),
            type: "text",
            shape: "circle",
            onClick: function onClick() {
              return setIsCommentEditing(true);
            },
            disabled: isUpdating
          })]
        }), /*#__PURE__*/_jsx(ScrollArea, {
          children: /*#__PURE__*/_jsx(Quoted, {
            children: renderComment()
          })
        })]
      }), /*#__PURE__*/_jsxs(LegendGroup, {
        children: [/*#__PURE__*/_jsxs(LegendItem, {
          children: [/*#__PURE__*/_jsx(LegendDot, {
            $color: styleVariables.colors.green1
          }), label.correct]
        }), /*#__PURE__*/_jsxs(LegendItem, {
          children: [/*#__PURE__*/_jsx(LegendDot, {
            $color: styleVariables.colors.red3
          }), label.inCorrect]
        }), /*#__PURE__*/_jsxs(LegendItem, {
          children: [/*#__PURE__*/_jsx(LegendDot, {
            $color: styleVariables.colors.blue2
          }), label.essayQuestion]
        })]
      })]
    })
  }));
};